import { getAppBasePath } from "@/core/appBase";
import { isSsoLoginStrategy } from "@/core/loginStrategy";
import { getRuntimeConfig } from "@/core/runtimeConfig";

export function goLogin(redirectPath) {
  if (isSsoLoginStrategy()) {
    const cfg = getRuntimeConfig();
    const clientType = cfg.LOGIN_SSO_CLIENT_TYPE || "OPEN";
    const targetUrl =
      cfg.LOGIN_SSO_TARGET_URL ||
      `${window.location.origin}${getAppBasePath()}`;
    window.location.href = `https://www.ringdata.com/user-center/login/${clientType}/${encodeURIComponent(
      targetUrl
    )}`;
    return;
  }

  import("@/router").then(({ default: router }) => {
    const query = {};
    if (redirectPath && typeof redirectPath === "string") {
      query.redirect = redirectPath;
    } else {
      const current = router.currentRoute.value?.fullPath;
      if (current && current !== "/login") {
        query.redirect = current;
      }
    }
    router.push({ path: "/login", query });
  });
}
